<template>
  <div>
    <ManageProduct365 />
  </div>
</template>
<script>
import ManageProduct365 from "@/components/Product365/ManageProduct365";
export default {
  components: {
    ManageProduct365,
  },
  created() {
  },
};
</script>